import { API_REQUEST, CURRENT_ANY_PROP_MAILING_ADDRESS, CURRENT_PROP_MAILING_ADDRESS, UPDATE_PROP_MAILING_ADDRESS} from "../../actionTypes/actionsTypes";
import { ActionType, AppAction, AppNoApiAction } from "../../types";

export const getCurrentPropMailingAddress = (roll: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/mailing-address/details/${roll}/yes`,
        next: CURRENT_PROP_MAILING_ADDRESS,
        method: 'GET',
        authorization: true
    }
});

export const getAnyPropMailingAddress = (roll: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/mailing-address/details/${roll}`,
        next: CURRENT_ANY_PROP_MAILING_ADDRESS,
        method: 'GET',
        authorization: true
    }
});

export interface UpdateMailingPayload{
    unit: string,
    city: string,
    addr: string,
    postal_code: string,
    province: string,
    email: string,

}

export const updateMailingAddress = (data: UpdateMailingPayload) => ({
    type: API_REQUEST,
    payload: {
        url: `/mailing-address/submit`,
        next: UPDATE_PROP_MAILING_ADDRESS,
        method: 'PUT',
        data: data,
        authorization: true
    }
})

export const resetCurrentPropMailingAddress = (): AppNoApiAction => ({
    type: CURRENT_PROP_MAILING_ADDRESS.RESET as ActionType
});

